<template>
  <!--
    icon="mdi-vuetify"
  -->
  <base-section id="immediate-steps">
    <!--
    <base-section-heading
      color="grey lighten-2"
      title="About Us"
    />
            @click="$vuetify.goTo(target, options)"
          {{ target }}
          {{ options }}
    -->
    <v-container>
      <div
        v-once
        id='scrollToNavImmediate'
        v-if="false"
      >
      <v-btn
        ref="button"
        text
        small
        color="primary"
        @click="handleClick('Doom')"
      >
        Scroll To Section: DOOM
      </v-btn>
      <v-btn
        ref="button"
        text
        small
        color="primary"
        @click="handleClick('Bloom')"
      >
        BLOOM
      </v-btn>
      <v-btn
        ref="button"
        text
        small
        color="primary"
        @click="handleClick('TenSteps')"
      >
        TEN STEPS
      </v-btn>
      <v-btn
        ref="button"
        text
        small
        color="primary"
        @click="handleClick('Misconceptions')"
      >
        Misconceptions
      </v-btn>
      </div>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="12"
        >
          <base-info-card v-bind="card" />

          <v-btn
            ref="button"
            text
            small
            color="primary"
            @click="handleClick('HeroClimate')"
          >
            Scroll To TOP
          </v-btn>

        </v-col>
      </v-row>
    </v-container>

    <span class="trace">ImmediateSteps.vue</span>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutUs',

    data: () => ({
      cards: [
        /*
        {
          title: 'Immediate Steps',
          subtitle: '',
          text: 'We provide information about local environmental issues and resources and organize practical projects aimed at reducing Truro’s collective carbon footprint and safeguarding Truro’s ecosystems.',
          callout: '',
        },
        {
          title: 'Our Vision',
          subtitle: '',
          text: 'We envision a resilient, ecologically healthy, environmentally responsible community living without pollutants in our air, water, and land.',
          callout: '',
        },
        */
        {
          title: 'Immediate Steps You Can Take',
          subtitle: '',
          html: '<span id="sectionTopImmediateSteps"><small></small></span><b>Truro’s 2020 Annual Town Meeting is September 26 at noon on the school ballfield. <br>These two votes are important for maintaining our environment in Truro.</b><ul><li>Vote <b>YES on Article 17</b>.  This Article, sponsored by the Truro Climate Action Committee and endorsed by the Energy Committee, sets the goal of eliminating Truro’s carbon footprint by 2050 at the latest, and needs to pass with as many votes as possible. Similar articles are being voted on in every Cape Cod town this year!</li><li>Vote <b>NO on Article 20</b>. This petitioned article attempts to remove our voices as voters from electing the Planning Board, and giving control of it to the Select Board. This undemocratic power grab doesn\'t even have the support of the Select Board or the Charter Review Committee, and is contrary to the traditions of the New England Town Meeting and Elections.</li></ul><br><b>In addition to voting, if you can, please consider these steps</b><ul><li>Get in touch with us! We will show you how decarbonize your household, organize your neighborhood, and/or help organize the town! Email <a href="mailto:info@climateactiontruro.org">info@climateactiontruro.org</a> or phone Michael Holt (508) 349-2120.</li><li>Read the rest of this page. It explains why climate breakdown is an emergency for Truro, and how responding to it will transform our community in many positive ways!</li><li>Face climate truth, both intellectually and emotionally. Educate yourself by reading <em>No One is Too Small to Make a Difference</em> by Greta Thunberg, <em>The Uninhabitable Earth</em> by David Wallace Wells, <em>This Changes Everything</em> by Naomi Klein, <em>On Fire</em> by Naomi Klein, <em>Facing the Climate Emergency</em> by Margaret Klein-Salomon, <em>The Sixth Mass Extinction</em> by Elizabeth Kolbert, and/or <em>A Planet to Win</em> by Alyssa Battistoni, et. al. Watch Greta Thunberg speeches, <a href="https://www.youtube.com/watch?v=1-RnnEFWUM4" target="blank">this short video</a><!--, <a href="https://mail.google.com/mail/u/0/?shva=1#search/inspiring+hopkins/FMfcgxwGDWxSZRDrpqsmCTLVQHgvPLSK?projector=1" target="blank">this inspiring film</a>,--> and <a href="https://www.youtube.com/watch?v=zbEnOYtsXHA" target="blank">this alarming one</a>. Let yourself feel the feelings these materials bring up, whether they are guilt, fear, anger, depression, despair, or wild, idealistic hope!</li><li>Talk about your feelings and concerns with friends and neighbors. Direct them to this page. Help us raise the alarm!</li><li>Sign up for Cape Light Compact’s free <a href="https://www.capelightcompact.org/home-energy-assessments/" target="blank">home</a> or <a href="https://www.capelightcompact.org/business/" target="blank">business</a> energy assessment. It will provide LED lights, insulation, and information that will save you money, energy, and carbon, and qualify you for important rebates.</li><li>If you get your electricity from Eversource, <a href="https://www.capelightcompact.org" target="blank">switch to Cape Light Compact</a> (CLC)</li><li>If you’re already with CLC, <a href="https://www.capelightcompact.org/clcgreen/" target="blank">upgrade</a> to their inexpensive “Local Green 50” renewable electricity package, or if you can afford it, their “Local Green 100” option. (See here [Misconception #6] for prices, and why only the latter is truly zero-carbon.)</li><li>Become a Climate Activist by taking the pledge <span hidden>[BE A CLIMATE ACTIVIST!]</span> to decarbonize your Truro household and business <span hidden>[TEN STEPS TO DECARBONIZING YOUR TRURO HOUSEHOLD OR BUSINESS]</span> by the end of 2030!</li><p id="sectionEndImmediateSteps"><small></small></p>',
          callout: '',
        },
      ],
      // target: "#sectionEndImmediateSteps",
      // target: "#sectionEndDoom",
      // target: '#sectionTopDoom',
      target: '#sectionTop',

      duration: 1000,
      offset: 100,
      easing: 'easeInOutCubic',
    }),

    computed: {
      options () {
        return {
          duration: this.duration,
          offset: this.offset,
          easing: this.easing,
        }
      },
    },

    methods: {
      handleClick: function (where) {
        // alert("target="+this.target+" options="+this.options)
        this.$vuetify.goTo(this.target + where, this.options)
        // alert(this.options)
        console.log('SCROLLING TO ', this.target, where)
        // this.$vuetify.goTo(-100, this.options)
      },
    },

  }

        /*
We are a grassroots, informal organization, inviting all interested members of the community to participate in our work.
We are committed to educating ourselves about the local impact of climate change and to finding environmentally responsible solutions.
We are committed to social justice, focusing on the consequences of climate change and environmental actions for all members of the community.
We are committed to green development and a strong local economy benefiting local businesses and workers producing food, goods, and services.

        {
          title: 'Target Setting',
          subtitle: 'Income Flow',
          text: 'Similique sunt in culpa qui officia deserunt mollitia animi, id est laborut dolorum fuga.harum quidem rerum facilis estexpedita distinctio.',
          callout: '03',
        },
        */

</script>

<style scoped>
  .em {
    font-size: 110%;
    color: red;
  }
  H5, h5 {
    font-size: 110%;
    color: blue;
  }
</style>
